import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = loc.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { nav("/admin/login"); return; }
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user);
        if (r.data.user.role === "customer") {
          nav("/", { state: { user: r.data.user } });
        } else {
          nav("/admin", { state: { user: r.data.user } });
        }
      } catch {
        nav("/admin/login?error=1");
      }
    })();
  }, [loc.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="label-eyebrow text-[hsl(var(--sk-fg))]/60">Signing you in…</p>
    </div>
  );
}
